<template>
  <div>
    <div class="row justify-content-center" v-if="stepBusinessData == 1">
      <div
        class="col-lg-5 col-12 text-center mb-4"
        v-if="businessList.length == 0"
      >
        <div>Search business by ABN or business name</div>
        <div class="form-group">
          <label class=""></label>
          <input-abn-lookup
            v-model="lead.abn"
            :class="[
              {
                'form-control is-invalid': form.errors.has('abn'),
              },
              'form-control border-0 p-0',
            ]"
            @data="updateAbnData($event, true)"
          />
          <div class="invalid-feedback">Please choose a ABN.</div>
        </div>
        <div class="text-grey">or</div>
        <div class="form-group">
          <label class=""></label>
          <div class="input-group">
            <input-business-name-lookup
              @data="updateAbnData($event, true)"
              @show-list="returnList"
              :return-list="true"
              v-model="lead.name"
              name="business_name"
              :class="[
                {
                  'form-control is-invalid': form.errors.has('name'),
                },
                'form-control border-0 p-0',
              ]"
            />
          </div>
        </div>
      </div>
      <div class="col-lg-7 col-12 mb-4" v-else v-loading="loading">
        <el-table :data="paginatedBusinessList" class="fa-sm" stripe>
          <el-table-column
            prop="ABN.identifierValue"
            label="ABN"
            width="120px"
          ></el-table-column>
          <el-table-column label="Name">
            <template slot-scope="scope">
              {{ getName(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="mainBusinessPhysicalAddress.postcode"
            label="Postcode"
            width="90px"
          ></el-table-column>
          <el-table-column
            prop="mainBusinessPhysicalAddress.stateCode"
            label="State"
            width="80px"
          ></el-table-column>

          <el-table-column align="right" width="150px">
            <template slot="header" slot-scope="scope">
              <el-input
                v-model="search"
                size="mini"
                placeholder="Type to search"
              />
            </template>
            <template slot-scope="scope">
              <el-button
                class="btn-primary"
                @click="selectBusiness(scope.row)"
                size="mini"
              >
                Select
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="text-right mt-2">
          <el-pagination
            layout="prev, pager, next"
            class="fa-sm"
            :total="
              businessList.filter(
                (business) =>
                  !search || getName(business).includes(search.toLowerCase())
              ).length
            "
            :page-size="pageSize"
            :current-page.sync="currentPage"
            @current-change="handlePageChange"
          ></el-pagination>
        </div>
        <div>
          <el-button class="btn-secondary px-4" @click="businessList = []">
            Cancel
          </el-button>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="stepBusinessData == 2">
      <div class="col-lg-5 col-12 mb-4">
        <div class="form-group">
          <label class="text-left">ABN</label>
          <div class="input-group">
            <input-abn-lookup
              v-model="lead.abn"
              :class="[
                {
                  'form-control is-invalid': form.errors.has('abn'),
                },
                'form-control border-0 p-0',
              ]"
              @data="updateAbnData"
            />
            <div class="invalid-feedback">Please enter a ABN.</div>
          </div>
        </div>
        <div class="form-group">
          <label class="">ACN</label>
          <div class="input-group">
            <input
              type="text"
              name="acn"
              @change="form.errors.clear('acn')"
              :class="[
                { 'is-invalid': form.errors.has('acn') },
                'form-control',
              ]"
              class="form-control w-100"
              v-model="lead.acn"
              placeholder="ACN"
            />
            <div class="invalid-feedback">Please choose a ACN.</div>
          </div>
        </div>
        <div class="form-group">
          <label class="text-left">Business Name</label>
          <div class="input-group">
            <input
              type="text"
              name="name"
              @change="form.errors.clear('name')"
              :class="[
                { 'is-invalid': form.errors.has('name') },
                'form-control',
              ]"
              class="form-control w-100"
              v-model="lead.name"
              placeholder="ACN"
            />
            <div class="invalid-feedback">Please choose a name.</div>
          </div>
        </div>
        <div class="form-group">
          <label class="text-left">Business type</label>
          <div class="input-group">
            <el-select
              filterable
              :class="[{ 'is-invalid': form.errors.has('business_type_id') }]"
              v-model="lead.business_type_id"
              clearable
              class="w-100"
              placeholder="Business Type"
            >
              <el-option
                v-for="item in businessTypes"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
            <div class="invalid-feedback">Please choose a business type.</div>
          </div>
        </div>
        <div class="form-group" v-if="lead.profile_type_id == 1">
          <label class="text-left">Year Established</label>
          <label class="text-grey float-right">{{
            lead.year_established && lead.year_established > 1000
              ? moment().diff(`${lead.year_established}-01-01`, "years") +
                " years"
              : ""
          }}</label>
          <div class="input-group">
            <input
              type="number"
              class="form-control"
              v-model="lead.year_established"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="pt-4 mt-4"></div>
    <div
      class="px-5 pb-4"
      v-if="showButtons"
      style="position: absolute; bottom: 0; left: 0; right: 0"
    >
      <div
        class="d-flex text-right"
        :class="
          stepBusinessData == 1 ||
          (stepBusinessData == 2 && onboardingAccount.is_completed == true)
            ? 'justify-content-end'
            : 'justify-content-between'
        "
      >
        <el-button
          class="btn-secondary px-4"
          v-if="
            (stepBusinessData > 1 && onboardingAccount.is_completed == false) ||
            (stepBusinessData > 2 && onboardingAccount.is_completed == true)
          "
          @click="stepBusinessData--"
        >
          Back
        </el-button>
        <div>
          <el-button
            class="btn-secondary px-4"
            @click="updateLead('save')"
            v-if="
              stepBusinessData > 1 && onboardingAccount.is_completed == false
            "
          >
            Save Progress
          </el-button>
          <el-button class="btn-secondary" @click="updateLead('next')">
            Next
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputAbnLookup from "../../../../common/InputAbnLookup.vue";
import InputBusinessNameLookup from "../../../../common/InputBusinessNameLookup.vue";
import AddressNotFound from "../../../../common/AddressNotFound.vue";
import AbnLookup from "../../../../frontend/modelsPortal/common/AbnLookup";
import Form from "form-backend-validation";
export default {
  components: {
    InputAbnLookup,
    InputBusinessNameLookup,
    AddressNotFound,
  },
  props: {
    initial_lead: {
      type: Object,
    },
    businessTypes: {
      type: Array,
    },
    onboardingAccount: {
      type: Object,
    },
  },
  data() {
    return {
      lead: { ...this.initial_lead },
      form: new Form(),
      not_found: false,
      address: {},
      generate_abn_pdf: false,
      stepBusinessData:
        this.initial_lead.abn || this.onboardingAccount.is_completed ? 2 : 1,
      showButtons:
        this.initial_lead.abn || this.onboardingAccount.is_completed
          ? true
          : false,
      businessList: [],
      currentPage: 1,
      pageSize: 10, // Number of items per page
      loading: false,
      search: "",
    };
  },
  computed: {
    paginatedBusinessList() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.businessList
        .filter(
          (business) =>
            !this.search ||
            this.getName(business).includes(this.search.toLowerCase())
        )
        .slice(start, end);
    },
  },
  methods: {
    handlePageChange(page) {
      this.currentPage = page;
    },

    getName(item) {
      let name = null;
      if (item.businessName) {
        name = item.businessName.organisationName;
      }
      if (item.mainName) {
        name = item.mainName.organisationName;
      }
      if (item.mainTradingName) {
        name = item.mainTradingName.organisationName;
      }
      if (item.otherTradingName) {
        name = item.otherTradingName.organisationName;
      }
      if (item.legalName) {
        name = item.legalName.fullName;
      }
      return name ? name.toLowerCase() : "";
    },
    returnList(data) {
      this.businessList = data;
      this.showButtons = false;
    },
    updateLead(action) {
      if (this.stepBusinessData < 2 && action == "next") {
        this.stepBusinessData++;
        action = "update";
      }
      this.$emit("update-lead", this.lead, action);
    },
    selectBusiness(business) {
      let params = { abn: business.ABN.identifierValue };
      this.loading = true;
      new AbnLookup()
        .params(params)
        .get()
        .then((res) => {
          let abnData = res[0];
          this.updateAbnData(abnData, true);
        })
        .catch((err) => {
          this.$message.error("Looks like something went wrong.");
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    updateAbnData(data, changeStep = false) {
      this.showButtons = true;
      this.businessList = [];
      if (data) {
        if (changeStep) this.stepBusinessData++;

        this.lead.name = data.name;
        this.lead.abn = data.abn;
        this.lead.acn = data.acn;
        if (data.entity_type) {
          let entityType = data.entity_type.split(" ");
          let businessTypes = this.businessTypes.filter((bt) =>
            entityType.some((word) => {
              return bt.name.toLowerCase().includes(word.toLowerCase());
            })
          );

          if (businessTypes.length == 1) {
            this.lead.business_type_id = businessTypes[0].id;
          }
        }
        this.generate_abn_pdf = true;
      } else this.generate_abn_pdf = false;
      this.abnResult = data;
    },
  },
};
</script>
